module.exports = __webpack_public_path__ + "static/image-03-a@2x-00825eaca3b633d0d10c472ac2fe95a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/zinc/image-03-a@2x.jpg
// module id = 438
// module chunks = 3627797113349 20562973939449 33019919093843